import { Injectable } from '@angular/core';

@Injectable()
export class DialogHelper {
  constructor() {}

  public showModal(btnId): void {
    const ele: HTMLElement = document.getElementById(btnId) as HTMLElement;
    if (ele) {
      ele.click();
    }

  }

  public writeToModal(message: string): void {
    const ele: HTMLElement = document.getElementById('errMsg') as HTMLElement;
    if (ele) {
      ele.innerText = message;
    }
  }

  public writeToModalWithMessageId(message: string, dangerMsgId: string): void {
    const ele: HTMLElement = document.getElementById(dangerMsgId) as HTMLElement;
    if (ele) {
      ele.innerText = message;
    }
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/helper/dialogHelper.ts